import { Component, OnInit } from '@angular/core';
import { FlowServiceService } from '../../Services/flow-service.service';

@Component({
  selector: 'app-law-enforcement',
  templateUrl: './law-enforcement.component.html',
  styleUrls: ['./law-enforcement.component.scss']
})
export class LawEnforcementComponent implements OnInit {
  sections = [
    { id: 'introduction', title: '1. Introduction' },
    { id: 'legal-requests', title: '2. Legal Requests' },
    { id: 'user-data', title: '3. User Data Requests' },
    { id: 'emergency', title: '4. Emergency Requests' },
    { id: 'preservation', title: '5. Data Preservation' },
    { id: 'contact', title: '6. Contact Information' }
  ];

  constructor(private flowServiceService: FlowServiceService) { 
    window.scrollTo(0,0);
    window.scroll({
      top: 0, 
      left: 0, 
      behavior: 'smooth'
    });
  }

  ngOnInit() {
    window.scrollTo(0,0)
    this.flowServiceService.setScrollTop();
  }
}

